// extracted by mini-css-extract-plugin
export default {"DashboardHeader":"styles_DashboardHeader__f520J","dropdowns":"styles_dropdowns__AZUeg","dropdownContainer":"styles_dropdownContainer__1lgYg"};